import React from 'react'

import QuickFilters from '../Filters/QuickFilters'
import LandingNav from '../LandingNav'
import MobileSearch from './MobileSearch'

type IProps = {
  isBottomDrawerOpen: boolean
  setIsBottomDrawerOpen: (open: boolean) => void
}

function NavBar({ isBottomDrawerOpen, setIsBottomDrawerOpen }: IProps) {
  return (
    <>
      <div className="hidden md:block">
        <LandingNav
          showSearch
          secondRow={
            <div className="px-5 py-2 md:px-8">
              <QuickFilters />
            </div>
          }
          className="h-[calc(var(--nav-h)+38px+16px)]"
        />
      </div>
      <div
        className="block md:hidden"
        onClick={() => isBottomDrawerOpen && setIsBottomDrawerOpen(false)}
      >
        <MobileSearch />
      </div>
    </>
  )
}

export default React.memo(NavBar)
